import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '../config';

export const LINE_RIDER_SCENE_KEY = 'LineRider';

/**
 * Concept 3 (Ride the Line) — placeholder.
 * The trend-reading runner lands after the Carb Quest loop is validated.
 */
export default class LineRiderScene extends Phaser.Scene {
  static readonly key = LINE_RIDER_SCENE_KEY;

  constructor() {
    super(LINE_RIDER_SCENE_KEY);
  }

  create(): void {
    const cx = GAME_WIDTH / 2;
    this.add
      .text(cx, 200, 'RIDE THE LINE', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '48px',
        color: '#4cc9f0',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    this.add
      .text(cx, 270, 'Surf your trend curve. Unlocks at Level 3.', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '20px',
        color: '#9fb4ff',
      })
      .setOrigin(0.5);

    const w = 300;
    const h = 52;
    const x = cx - w / 2;
    const y = 360;
    this.add.graphics().fillStyle(0x273052, 1).fillRoundedRect(x, y, w, h, 12);
    this.add
      .text(cx, y + h / 2, 'Back to the Keep', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '20px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
    this.add
      .zone(cx, y + h / 2, w, h) // centered: zone origin is (0.5, 0.5)
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.scene.start('Menu'));
    void GAME_HEIGHT;
  }
}
